import { IconMapPins } from '@tabler/icons';

import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
} from '#root/components/ui';
import styles from './styles.module.scss';

interface CurrentDeliverySetupDialogProps {
  open: boolean;
  onClose: () => void;
}

/** Qué implica compartir una Configuración de Entrega con el comprador de un acuerdo. */
const CurrentDeliverySetupDialog = (props: CurrentDeliverySetupDialogProps) => {
  const { open = false, onClose } = props;

  return (
    <Modal open={open} onClose={onClose}>
      <ModalHeader icon={<IconMapPins />} tone="info">
        <ModalTitle>Compartiendo una Configuración de Entrega</ModalTitle>
      </ModalHeader>
      <ModalBody>
        <div className={styles.text}>
          <p>
            Cuando compartes una <strong>Configuración de Entrega</strong>, el comprador puede ver
            la información que has predefinido y contactarte al número de teléfono o whatsapp que
            has proporcionado, a fin de concretar la entrega.
          </p>
          <p>
            Una vez que alguno de los dos haya confirmado la entrega, se dejará de compartir la{' '}
            <strong>Configuración de Entrega</strong>.
          </p>
        </div>
        <ul className={styles.cases}>
          <li>Si el comprador no te ha contactado, contáctalo.</li>
          <li>
            Si el comprador te ha contactado, pero aún no se acerca a recoger su pedido (y han
            pasado al menos 5 días), comunícate con Guvery para más alternativas de entrega.
          </li>
          <li>
            Si has tenido una mala experiencia con un comprador y quieres dejar de compartirle tu{' '}
            <strong>Configuración de Entrega</strong> comunícate con Guvery para poder hacerlo.
          </li>
        </ul>
      </ModalBody>
      <ModalFooter>
        <Button variant="outline" onClick={onClose}>
          Cerrar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default CurrentDeliverySetupDialog;
